export default __webpack_public_path__ + "static/ArminGrotesk-Normal-2c9fab7dc7234fc859d3f9208f6ed3f8.woff2";